<template>
  <div class="milestones-inline">
    <MilestonesBlock
      v-model="milestones"
      :milestone-block-state="MilestoneEditState.editing"
      :currency
    />
  </div>
  <div v-show="false">
    <div v-for="(milestone, index) in milestones" :key="milestone.id">
      <input type="hidden" :name="`milestones[${index}][name]`" :value="milestone.name" />
      <input
        type="hidden"
        :name="`milestones[${index}][poNumber]`"
        :value="milestone.purchaseOrderNumber"
      />
      <input
        type="hidden"
        :name="`milestones[${index}][amount]`"
        :value="milestoneDetails(milestone).amount"
      />
      <input
        type="hidden"
        :name="`milestones[${index}][dueDate]`"
        :value="milestoneDetails(milestone).dueDate"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, Ref, watch } from 'vue'
import MilestonesBlock from '@/components/Milestones/MilestonesBlock.vue'
import { MilestoneEditState } from '@/components/Milestones/types'
import { MilestoneStatus, MilestoneTypeFragment } from '@/gql/graphql'
import { uuid } from '@/utils/tools'

const milestones: Ref<MilestoneTypeFragment[]> = ref([])

const milestoneDetails = (milestone: MilestoneTypeFragment) => milestone.details

const totalRate = defineModel<string>('rate')

interface MilestoneFormInput {
  name: string
  poNumber: string
  amount: string
  dueDate: string
}

defineProps<{
  currency?: string
}>()

const milestonesFormInput = defineModel<MilestoneFormInput[]>('milestonesFormInput', {
  required: false,
  default: () => [],
})

onMounted(() => {
  milestones.value = milestonesFormInput.value.map(
    (milestone: MilestoneFormInput): MilestoneTypeFragment => ({
      id: uuid(),
      name: milestone.name,
      purchaseOrderNumber: milestone.poNumber,
      status: MilestoneStatus.Pending,
      details: {
        id: uuid(),
        amount: parseFloat(milestone.amount),
        dueDate: milestone.dueDate,
      },
    }),
  )
})

watch(
  milestones,
  () => {
    totalRate.value = `${milestones.value.reduce(
      (acc: number, milestone: MilestoneTypeFragment): number => {
        const { details } = milestone

        const parsed = details.amount
        if (isNaN(parsed)) {
          return acc
        }

        return parsed + acc
      },
      0,
    )}`
  },
  { deep: true },
)
</script>

<style lang="scss" scoped>
@tailwind base;

.milestones-inline {
  padding: 24px 16px;
  border: 1px solid var(--default-gray-gray-300-dfdfe-6, #dfdfe6);
  @apply tw-rounded;
}
</style>
